import { action, observable } from 'mobx';
import { BaseListViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { ScheduleService } from 'application/schedule/services';
@applicationContext
class TaskCommentsModalStore extends BaseListViewStore {
    @observable accessor notifications = [];
    constructor(rootStore, componentProps) {
        const modalParams = componentProps.modalParams;
        const id = modalParams.data && modalParams.data.item.id;
        const service = new ScheduleService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'task-notifications',
            id: id,
            actions: () => {},
        });

        this.modalParams = modalParams;
        this.item = modalParams.data && modalParams.data.item;
        this.service = service;
    }

    @action.bound
    onViewMessage(id) {
        this.rootStore.routerStore.goTo(
            'master.app.main.schedule.calendar',
            null,{ taskId: id }
        );
    }

}

export default TaskCommentsModalStore;
